(function($) {

    function accordionCalcs() {
        $('.committee-item').addClass('expanded');

        $('.committee-body').each(function () {
            $(this).css('height', 'auto').css('height', $(this).outerHeight(true));
            $(this).parent().removeClass('expanded');
        });
    }

    $('.committee-head').on('click', function () {
        $(this).parent().toggleClass('expanded');
    });

    $(window).on('load', function() {
        accordionCalcs();
    });

    $(window).on('resize', function () {
        accordionCalcs();
    });

})( jQuery );